import { render, staticRenderFns } from "./cSearchPageRecommend.vue?vue&type=template&id=13d9eefa&scoped=true"
import script from "./cSearchPageRecommend.vue?vue&type=script&lang=js"
export * from "./cSearchPageRecommend.vue?vue&type=script&lang=js"
import style0 from "./cSearchPageRecommend.vue?vue&type=style&index=0&id=13d9eefa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d9eefa",
  null
  
)

export default component.exports